// hooks/useAtualizarDados.ts
import { useState } from "react";
import { IndicacaoParceiro } from "../../../interfaces/IndicacaoParceiro";
import { cadastrarLead } from "../../../services/cadastrarLeadService";
import { buscarUsuarioProprietarioByCel } from "../../../services/buscarUsuarioProprietarioByCelService";
import { buscarLeadsByCelService } from "../../../services/buscarLeadsByCelService";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
import { buscarParceiroByNome } from "../../../services/buscarParceiroByNomeService";
import { cadastrarIndicacaoParceiro } from "../../../services/cadastrarIndicacaoParceiroService";
import { cadastrarParceiro } from "../../../services/cadastrarParceiroService";
// --------------------- Import Services ---------------------

export const useCadastrarIndicacoesParceiros = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const obterOuCadastrarLead = async (data: any) => {
    let tipoLead = null;
    const celularFormatado = numberPadrao(data.celular);

    const lead = await buscarLeadsByCelService(celularFormatado);

    if (lead) {
      return lead.id;
    }

    const usuarioProprietario = await buscarUsuarioProprietarioByCel(
      celularFormatado
    );

    // Verifica se o número pertence a um usuário
    if (usuarioProprietario) {
      // Verifica se o usuário é proprietário
      if (usuarioProprietario.CotaUsuario.length > 0) {
        tipoLead = "PROPRIETARIO";
      } else {
        tipoLead = "LEAD";
      }
    } else {
      tipoLead = "LEAD";
    }

    const novoLead = await cadastrarLead({
      nome: data.nome,
      celular: celularFormatado,
      active: 1,
      status: "DIVULGAR",
      tipo: tipoLead,
    });

    return novoLead.id;
  };

  const cadastrar = async (indicacaoData: Partial<IndicacaoParceiro>) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const idLead = await obterOuCadastrarLead(indicacaoData);
      const idParceiro = indicacaoData.idParceiro;

      const data = {
        idLeads: idLead,
        idParceiro: idParceiro,
        status: "VERIFICAR",
        active: 1,
      };

      const cadastrarDados = await cadastrarIndicacaoParceiro(data);

      if (cadastrarDados) {
        setSuccess(true);
      } else {
        setError(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
